import { defineComponent } from "vue";
import { useI18n } from "../../locales/index.mjs";
import SvgIcon from "../common/base/SvgIcon.vue.mjs";
import LoadingScheduleIcon from "../common/icons/LoadingScheduleIcon.vue.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "LoadingOverlay",
  setup(__props) {
    const { t } = useI18n();
    return { __sfc: true, t, SvgIcon, LoadingScheduleIcon };
  }
});
export {
  _sfc_main as default
};
